import { ILocation } from '../api/locations';

export function locationHasNeighbors(location: ILocation | 'moscow_mo' | 'spb_lo'): boolean {
  if (location === 'moscow_mo' || location === 'spb_lo') {
    return false;
  }

  return location.hasNeighbors;
}
